import { useRegisterSection } from '~/hooks/useSections';
import { MicrositeTemplate } from '~/model';
import FloorplanBlockAlpha from '~/editor/templates/alpha/FloorplanBlockAlpha';
import FloorplanBlockBeta from '~/editor/templates/beta/FloorplanBlockBeta';
import FloorplanBlockDelta from '~/editor/templates/delta/FloorplanBlockDelta';
import FloorplanBlockEpsilon from '~/editor/templates/epsilon/FloorplanBlockEpsilon';
import FloorplanBlockEta from '~/editor/templates/eta/FloorplanBlockEta';
import FloorplanBlockZeta from '~/editor/templates/zeta/FloorplanBlockZeta';
import { DEMO_FLOORPLANS } from '~/demo';
import type { ComponentConfig } from '@puckeditor/core';

export interface FloorplanBlockProps {
	navigation?: boolean;
	title?: string;
	template: MicrositeTemplate;
}

export const PUCK_BLOCK_FLOORPLAN: ComponentConfig<FloorplanBlockProps> = {
	label: 'Floorplans',
	fields: {
		navigation: {
			type: 'radio',
			options: [
				{ label: 'On', value: true },
				{ label: 'Off', value: false },
			],
		},
		template: {
			type: 'radio',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
				{ label: 'Delta', value: MicrositeTemplate.DELTA },
				{ label: 'Epsilon', value: MicrositeTemplate.EPSILON },
				{ label: 'Eta', value: MicrositeTemplate.ETA },
				{ label: 'Zeta', value: MicrositeTemplate.ZETA },
			],
		},
	},
	defaultProps: {
		navigation: true,
		title: 'Floorplans',
		template: MicrositeTemplate.ETA,
	},
	permissions: {
		duplicate: false,
	},
	render(props) {
		return <FloorplanBlock {...props} />;
	},
};

export default function FloorplanBlock({ navigation, title, template }: FloorplanBlockProps) {
	const id = useRegisterSection('floorplans', title, navigation);

	if (template === MicrositeTemplate.ALPHA) {
		return (
			<div id={id}>
				<FloorplanBlockAlpha floors={DEMO_FLOORPLANS} />
			</div>
		);
	}
	if (template === MicrositeTemplate.BETA) {
		return <FloorplanBlockBeta id={id} images={DEMO_FLOORPLANS} />;
	}
	if (template === MicrositeTemplate.DELTA) {
		return (
			<div id={id}>
				<FloorplanBlockDelta floors={DEMO_FLOORPLANS} />
			</div>
		);
	}
	if (template === MicrositeTemplate.EPSILON) {
		return (
			<div id={id}>
				<FloorplanBlockEpsilon floors={DEMO_FLOORPLANS} />
			</div>
		);
	}
	if (template === MicrositeTemplate.ZETA) {
		return (
			<div id={id}>
				<FloorplanBlockZeta floors={DEMO_FLOORPLANS} />
			</div>
		);
	}

	return (
		<div id={id}>
			<FloorplanBlockEta floors={DEMO_FLOORPLANS} />
		</div>
	);
}
